import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Divider,
} from "@mui/material";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";

const CarbonFootprintCard = ({ carbonData, resetForm }) => {
  // Safely check if carbonData and related fields are defined
  const carbonFootprint = carbonData.data?.totalEmission;
  const fuelConsumptionValue = carbonData.data?.fuelEfficiency?.value ?? 0;
  const fuelConsumptionUnit = carbonData.data?.fuelEfficiency?.unit ?? "";
  const distance = carbonData.data?.distanceCovered;
  const vehicle = carbonData.data?.vehicleName;
  const fuelType = carbonData.data?.fuel;
  const source = carbonData.data?.source;
  const destination = carbonData.data?.destination;



  return (
    <Card
      style={{
        maxWidth: "100%",
        marginTop: "2%",
        padding: "20px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      }}
    >
      <CardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            Your Carbon Footprint
          </Typography>
          <Button variant="outlined" size="small" onClick={resetForm}>
            RESET
          </Button>
        </Box>
        <Divider />
        <Box my={3} textAlign="left">
          <Typography
            variant="h5"
            color="textPrimary"
            style={{ fontWeight: "bold" }}
          >
            {carbonFootprint !== undefined
              ? `${carbonFootprint.toFixed(5)} KgCO₂e`
              : "No data available"}
          </Typography>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Box textAlign="left">
            <Typography variant="body2">
              Vehicle: <strong>{vehicle || "N/A"}</strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Source: <strong>{source || "N/A"}</strong>
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Box display="flex" alignItems="center" mb={1}>
              <LocalGasStationIcon style={{ color: "red", marginRight: 4 }} />
              <Typography variant="body2">
                {fuelConsumptionValue !== undefined
                  ? `${fuelConsumptionValue.toFixed(5)} ${fuelConsumptionUnit}`
                  : "N/A"}
              </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              sx={{ marginRight: "1.9rem" }}
            >
              <ArrowCircleLeftIcon style={{ color: "blue" }} />
              <Typography variant="body2">
                {distance !== undefined ? `${distance.toFixed(3)} KM` : "N/A"}
              </Typography>
              <ArrowCircleRightIcon style={{ color: "blue" }} />
            </Box>
          </Box>
          <Box textAlign="right">
            <Typography variant="body2">
              Fuel: <strong>{fuelType || "N/A"}</strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Destination: <strong>{destination || "N/A"}</strong>
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CarbonFootprintCard;
